import {ApiComm} from "../comm";
import { BookStatus, RecordType, ScriptStatus, ApplicantStatus } from "../common/enums";
import {MissiondoneTypeDTO, BookeventInputReqDTO, BookeventInfoDTO, BookeventApplicantInfoDTO, BookeventMissiondoneLinkDTO, BookeventMissiondoneLinkInputReqDTO} from "../dto/BookeventDTOs";
import {ResponseDTO} from "../dto/ResponseDTO";
import { NoobookFileInfoDTO } from "../dto/CommonDTOs";
import {genNoobookHeader} from "./Common";
import _ from "lodash";

export function uploadBookEventImageToTmpFile(authToken:string, file:File):Promise<ResponseDTO<NoobookFileInfoDTO>>
{
    return ApiComm.postFormData<ResponseDTO<NoobookFileInfoDTO>>(`/close/v1/bookevent/image`
        , {file:file}
        , genNoobookHeader(authToken, null, 'multipart/form-data', "app")
    ).then(resp=>resp.data);
}



export function getMissiondoneTypes(authToken:string):Promise<ResponseDTO<MissiondoneTypeDTO[]>>
{
    return ApiComm.getData<ResponseDTO<MissiondoneTypeDTO[]>>(`/close/v1/bookevent/missiondone_types`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function createBookevent(authToken:string, bookeventInput:BookeventInputReqDTO):Promise<ResponseDTO<BookeventInfoDTO>>
{
    return ApiComm.postData<ResponseDTO<BookeventInfoDTO>>(`/close/v1/bookevent`
        , bookeventInput
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function modifyBookevent(authToken:string, bookeventId:number, bookeventInput:BookeventInputReqDTO):Promise<ResponseDTO<BookeventInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookeventInfoDTO>>(`/close/v1/bookevent/${bookeventId}`
        , bookeventInput
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function deleteBookevent(authToken:string, bookeventId:number):Promise<ResponseDTO<BookeventInfoDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookeventInfoDTO>>(`/close/v1/bookevent/${bookeventId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookevent(authToken:string, bookeventId:number):Promise<ResponseDTO<BookeventInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookeventInfoDTO>>(`/close/v1/bookevent/${bookeventId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getBookeventsByHashtag(authToken:string, hashtag:string, deadlineCommingEvent:boolean, page:number, size:number):Promise<ResponseDTO<BookeventInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookeventInfoDTO[]>>(`/close/v1/bookevent/hashtag/bookevents`
        , {hashtag:hashtag, recruitToFr: deadlineCommingEvent ? new Date() : null, recruitToTo:null, sort:(deadlineCommingEvent ? "be.recruit_to,asc" : "be.created_at,desc"), page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

	


export function getBookeventApplicant(authToken:string, bookeventId:number):Promise<ResponseDTO<BookeventApplicantInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookeventApplicantInfoDTO>>(`/close/v1/bookevent/${bookeventId}/applicant`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getBookeventApplicants(authToken:string, bookeventId:number, loginid:string, name:string, email:string, accepted:ApplicantStatus, page:number, size:number):Promise<ResponseDTO<BookeventApplicantInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookeventApplicantInfoDTO[]>>(`/close/v1/bookevent/${bookeventId}/applicants`
        , {sort:["accepted,asc", "createdAt,desc"], loginid:loginid || undefined, name:name || undefined, email:email || undefined, accepted:accepted || undefined, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function applyToBookevent(authToken:string, bookeventId:number):Promise<ResponseDTO<BookeventApplicantInfoDTO>>
{
    return ApiComm.postData<ResponseDTO<BookeventApplicantInfoDTO>>(`/close/v1/bookevent/${bookeventId}/applicant`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function cancelToBookevent(authToken:string, bookeventId:number):Promise<ResponseDTO<BookeventApplicantInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookeventApplicantInfoDTO>>(`/close/v1/bookevent/${bookeventId}/applicant/cancel`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function acceptToBookevent(authToken:string, applicantId:number, bookeventId:number):Promise<ResponseDTO<BookeventApplicantInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookeventApplicantInfoDTO>>(`/close/v1/bookevent/${bookeventId}/applicant/${applicantId}/accept`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}   

export function rejectToBookevent(authToken:string, applicantId:number, bookeventId:number):Promise<ResponseDTO<BookeventApplicantInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookeventApplicantInfoDTO>>(`/close/v1/bookevent/${bookeventId}/applicant/${applicantId}/reject`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function putMissiondoneLinks(authToken:string, bookeventId:number, missiondoneLinks:BookeventMissiondoneLinkInputReqDTO[]):Promise<ResponseDTO<BookeventMissiondoneLinkDTO[]>>
{
    return ApiComm.putData<ResponseDTO<BookeventMissiondoneLinkDTO[]>>(`/close/v1/bookevent/${bookeventId}/applicant/missiondoneLinks`
        , missiondoneLinks
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}





